import * as React from "react";
import {Row, Col} from "react-bootstrap";
import "./index.scss";
import { ITab } from "./tab";

interface IState {
    active?: number;    
}

interface IProps {
    className?: string;
    add?: boolean;
    onClick?: () => void;
    addTitle?: string;
    addTabClassName?: string;
}

/**
 * Real simple tab system
 */
export default class Tabs extends React.Component<IProps, IState> {

    constructor(props){
        super(props);
        this.setDefaultTab();
    }

    hasChildren() : boolean {
        return !(this.props.children == null || (this.props.children as any).length == 0);
    }

    /**
     * Sets the default tab (usually run on the component mounts)
     */
    setDefaultTab(){

        if (!this.hasChildren()){
            this.state = {};
            return null;
        }

        if ((this.props.children as any).length){
            this.state = {
                active: ((this.props.children[0] as any).props as ITab).id
            };
        } else {
            this.state = {
                active: ((this.props.children as any).props as ITab).id
            };
        }
    }


    getProps(child) : ITab {
        return ((child as any).props as ITab);
    }

    /**
     * Sets the id
     * @param id 
     */
    setTab( id : number){
        this.setState({active: id});
    }

    /**
     * Gets the child to render
     */
    getChild() : React.ReactNode {

        if (!this.hasChildren()){
            return null;
        }

        return React.Children.toArray(this.props.children)
            .filter(child => {
                return ((child as any).props as ITab).id == this.state.active
            })[0]
    }

    renderHeading( child : React.ReactNode) {
        return (      
            <div className={`tab-header px-3 mx-2${this.state.active == this.getProps(child).id ? " active": ""}`} onClick={() => this.setTab(this.getProps(child).id)}>
                <div>
                    <p className="mb-0"><b>{this.getProps(child).title}</b></p>
                    {this.getProps(child).subTitle ?  <span className="sub-title text-muted">{this.getProps(child).subTitle}</span> : null}              
                </div>            
            </div>
        )
    }


    renderAdd() {
        return (
            <div className={`tab-header px-3 mx-2 d-flex align-items-center ${this.props.addTabClassName}`} onClick={() => this.props.onClick()}>
                <i className="material-icons">add</i>    
                {this.props.addTitle}
            </div>
        )
    }

    render(){
        return (
            <div className={`custom-tabs ${this.props.className || ""}`}>
                <div className="tab-heading-holder d-flex align-items-center">
                    {React.Children.map(this.props.children, child => this.renderHeading(child))}
                    {this.props.add ? this.renderAdd() : null}
                </div>
                {
                    this.hasChildren() ? 
                        <div className={`tab-contents ${this.state.active == this.getProps(this.getChild()).id ? "d-block" : "d-none"}`}>
                            {this.getChild()}
                        </div> : null
                }
                
            </div>
        )
    }
}